import hash from "object-hash";
import deepEqual from "deep-equal";

export default {
  nameSpace: false,
  state: {
    userLoggedIn: false,
    userInvalid: null,
    accounts: [
      "58ea8a737ab6fb53612b425edd436292539b1637",
    ]
  },
  getters: {},
  mutations: {
    checkLogin: (state, data) => {
      state.userLoggedIn = data.valid;
      state.userInvalid = null;

      setTimeout(() => {
        if (data.valid) {
          state.userInvalid = false;
          window.localStorage.setItem("userLoggedIn", data.hash);
        } else {
          state.userInvalid = true;
        }
      }, 0);
    }
  },
  actions: {
    LOGIN_USER(
      {state, commit, dispatch},
      {fields, isLocalStorage = false, localStorageItem = null}
    ) {
      // check if user input matches any of our accounts
      const checkLogin = (fields, isLocalStorage, localStorageItem) => {
        if (fields || isLocalStorage) {
          for (let i = 0; i < state.accounts.length; i++) {
            const userData = isLocalStorage
              ? localStorageItem
              : hash(['molonglo', fields.password]);
            if (deepEqual(state.accounts[i], userData)) {
              return {
                valid: true,
                hash: userData
              };
            }
          }
        }

        return {
          valid: false
        };
      };

      const response = checkLogin(fields, isLocalStorage, localStorageItem);
      commit("setLoading", true);
      dispatch("CHECK_LOGIN", response);
    },
    CHECK_LOGIN({state, commit, rootState}, data) {
      commit("setLoading", false);
      commit("checkLogin", data);
    },
  }
};
